import { CtaButton } from "./CtaButton";

import type { AdsLandingPrefooter } from "./types";

export function Prefooter({ prefooter }: { prefooter: AdsLandingPrefooter }) {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-6 pt-[120px]">
      <div className="bg-surface-secondary rounded-md px-6 py-16 md:py-24">
        <div className="mx-auto flex w-full max-w-[744px] flex-col items-center gap-8 text-center">
          <div className="text-primary flex w-full flex-col items-center gap-6">
            <h2 className="w-full text-[48px] leading-[1.16] font-medium text-balance">
              {prefooter.headline}
            </h2>
            {prefooter.subtext ?
              <p className="max-w-[596px] text-[17px] leading-7 text-balance">
                {prefooter.subtext}
              </p>
            : null}
          </div>

          {prefooter.ctas.length > 0 ?
            <div className="flex flex-wrap items-center justify-center gap-3">
              {prefooter.ctas.map((cta) => (
                <CtaButton key={`${cta.label}-${cta.variant}`} cta={cta} />
              ))}
            </div>
          : null}
        </div>
      </div>
    </section>
  );
}
